module.exports = __webpack_public_path__ + "static/media/mobileScreenshot09.d77b70d8.jpg";